<template>
  <div class="app-root">
    <header class="top-bar">
      <div class="top-bar-left">
        <img class="logo-mark" :src="siteIconUrl" width="32" height="32" alt="" />
        <div class="logo-text-group">
          <span class="logo-title">科研工作台</span>
<!--          <span class="logo-subtitle">Beta版</span>-->
        </div>
      </div>
      <div class="top-bar-right">
        <div class="avatar" aria-hidden="true"></div>
      </div>
    </header>

    <div class="layout">
      <aside class="sidebar">
        <div class="sidebar-section">
          <button
            class="nav-item"
            :class="{ 'nav-item--active': isAnalysis }"
            type="button"
            @click="goAnalysis"
          >
            <span class="nav-icon">📊</span>
            <span class="nav-label">数据分析</span>
          </button>
        </div>
      </aside>

      <main class="main">
        <slot />
      </main>
    </div>

    <!-- 默认收起：左下角入口；点击展开弹层 -->
    <button
      type="button"
      class="disclaimer-trigger"
      aria-haspopup="dialog"
      :aria-expanded="disclaimerOpen"
      aria-controls="disclaimer-dialog"
      @click="openDisclaimer"
    >
      <span class="disclaimer-trigger-icon" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7 3h8a2 2 0 012 2v14l-4-2-4 2V5a2 2 0 00-2-2z"
            stroke="currentColor"
            stroke-width="1.75"
            stroke-linejoin="round"
          />
          <path d="M9 8h6M9 12h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <path
            d="M17 19l3 2V7a2 2 0 00-2-2h-1"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </span>
      <span class="disclaimer-trigger-text">程序声明</span>
    </button>

    <Teleport to="body">
      <div
        v-if="disclaimerOpen"
        id="disclaimer-dialog"
        class="disclaimer-backdrop"
        role="presentation"
        @click.self="closeDisclaimer"
      >
        <div
          class="disclaimer-panel"
          role="dialog"
          aria-modal="true"
          aria-labelledby="disclaimer-title"
          @click.stop
        >
          <div class="disclaimer-panel-head">
            <div class="disclaimer-panel-brand" aria-hidden="true">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="3" width="14" height="18" rx="2" stroke="#5eead4" stroke-width="1.5" />
                <path d="M8 8h8M8 12h6" stroke="#99f6e4" stroke-width="1.25" stroke-linecap="round" />
              </svg>
            </div>
            <button
              type="button"
              class="disclaimer-panel-close"
              aria-label="关闭"
              @click="closeDisclaimer"
            >
              ×
            </button>
          </div>

          <h2 id="disclaimer-title" class="disclaimer-panel-title">程序声明</h2>

          <div class="disclaimer-steps">
            <div class="d-row">
              <span class="d-num">01</span>
              <p class="d-txt">
                本程序产生或展示的内容仅供参考，务必严格确认后引用发表，本站点及单位不承担任何责任；
              </p>
              <div class="d-line" aria-hidden="true"></div>
            </div>
            <div class="d-row">
              <span class="d-num">02</span>
              <p class="d-txt">
                严禁对本程序进行逆向分析和破解等行为，保留追责权利；
              </p>
              <div class="d-line" aria-hidden="true"></div>
            </div>
            <div class="d-row">
              <span class="d-num">03</span>
              <p class="d-txt">
                若使用，则代表同意<span class="d-link">上述观点</span>，本站点及单位具有最终解释权；
              </p>
              <div class="d-line" aria-hidden="true"></div>
            </div>
            <div class="d-row d-row--last">
              <span class="d-num">04</span>
              <p class="d-txt">
                本程序将持续更新与改进，欢迎大家提出<span class="d-link">意见或建议</span>~
              </p>
            </div>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
export default {
  name: 'AppLayout',
  data() {
    return {
      disclaimerOpen: false,
    };
  },
  computed: {
    siteIconUrl() {
      return `${process.env.BASE_URL}favicon.ico`;
    },
    isAnalysis() {
      return this.$route.path.startsWith('/analysis');
    },
  },
  mounted() {
    this._onEsc = (e) => {
      if (e.key === 'Escape' && this.disclaimerOpen) this.closeDisclaimer();
    };
    window.addEventListener('keydown', this._onEsc);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this._onEsc);
  },
  methods: {
    goAnalysis() {
      if (!this.isAnalysis) this.$router.push({ name: 'analysis' });
    },
    openDisclaimer() {
      this.disclaimerOpen = true;
    },
    closeDisclaimer() {
      this.disclaimerOpen = false;
    },
  },
};
</script>

<style scoped>
.app-root {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.top-bar {
  height: 56px;
  padding: 0 24px;
  background: var(--rw-primary);
  color: #ecfeff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 6px rgba(15, 118, 110, 0.28);
}

.top-bar-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-mark {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  display: block;
  object-fit: cover;
  flex-shrink: 0;
}

.logo-text-group {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.logo-title {
  font-size: 18px;
  font-weight: 600;
}

.logo-subtitle {
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid rgba(240, 253, 250, 0.8);
  font-size: 11px;
}

.top-bar-right {
  display: flex;
  align-items: center;
  gap: 14px;
}

.avatar {
  width: 30px;
  height: 30px;
  border-radius: 999px;
  background: radial-gradient(circle at 30% 20%, #fff, #0f766e);
  border: 2px solid rgba(240, 253, 250, 0.85);
}

.layout {
  flex: 1;
  display: flex;
  padding: 16px 18px 20px;
  gap: 16px;
  min-height: 0;
}

.sidebar {
  width: 72px;
  background: var(--rw-white);
  border-radius: 18px;
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow:
    0 18px 40px rgba(15, 23, 42, 0.12),
    0 0 0 1px rgba(148, 163, 184, 0.18);
}

.sidebar-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.nav-item {
  border: none;
  background: transparent;
  border-radius: 14px;
  padding: 10px 0 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  color: var(--rw-muted);
  font-size: 11px;
  cursor: pointer;
}

.nav-item--active {
  background: linear-gradient(145deg, var(--rw-primary-2), var(--rw-primary-3));
  color: #ffffff;
  box-shadow: 0 8px 20px rgba(34, 193, 195, 0.55);
}

.nav-icon {
  font-size: 16px;
}

.nav-label {
  white-space: nowrap;
}

.main {
  flex: 1;
  background: var(--rw-panel);
  border-radius: 22px;
  padding: 18px 22px 20px;
  box-shadow: var(--rw-shadow), 0 0 0 1px rgba(148, 163, 184, 0.2);
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

@media (max-width: 960px) {
  .layout {
    padding: 12px;
  }

  .sidebar {
    display: none;
  }
}

/* 左下角：收起态入口 */
.disclaimer-trigger {
  position: fixed;
  z-index: 100;
  left: 0;
  bottom: max(10px, env(safe-area-inset-bottom, 0px));
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px 10px 12px;
  border: 1px solid rgba(45, 212, 191, 0.45);
  border-radius: 14px;
  background: linear-gradient(165deg, rgba(240, 253, 250, 0.98), rgba(204, 251, 241, 0.92));
  color: #0f766e;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  box-shadow:
    0 10px 28px rgba(15, 118, 110, 0.18),
    0 0 0 1px rgba(255, 255, 255, 0.6) inset;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.disclaimer-trigger:hover {
  transform: translateY(-1px);
  box-shadow:
    0 14px 32px rgba(15, 118, 110, 0.22),
    0 0 0 1px rgba(255, 255, 255, 0.7) inset;
}

.disclaimer-trigger-icon {
  display: flex;
  color: #0d9488;
}

.disclaimer-trigger-text {
  letter-spacing: 0.3px;
}

/* 弹层 */
.disclaimer-backdrop {
  position: fixed;
  inset: 0;
  z-index: 8000;
  background: rgba(15, 23, 42, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
}

.disclaimer-panel {
  width: min(480px, 100%);
  max-height: min(86vh, 640px);
  overflow: auto;
  background: #fff;
  border-radius: 18px;
  padding: 18px 20px 22px;
  box-shadow:
    0 28px 60px rgba(15, 23, 42, 0.22),
    0 0 0 1px rgba(148, 163, 184, 0.2);
}

.disclaimer-panel-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 4px;
}

.disclaimer-panel-brand {
  opacity: 0.95;
}

.disclaimer-panel-close {
  border: none;
  background: transparent;
  font-size: 24px;
  line-height: 1;
  color: #94a3b8;
  cursor: pointer;
  padding: 0 4px;
  margin: -4px -4px 0 0;
}

.disclaimer-panel-close:hover {
  color: #0f172a;
}

.disclaimer-panel-title {
  margin: 0 0 16px;
  font-size: 17px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: 0.5px;
}

.disclaimer-steps {
  position: relative;
  padding-left: 0;
}

.d-row {
  position: relative;
  display: grid;
  grid-template-columns: 36px 1fr;
  column-gap: 10px;
  align-items: start;
  margin-bottom: 14px;
}

.d-row--last {
  margin-bottom: 0;
}

.d-num {
  grid-column: 1;
  grid-row: 1;
  font-size: 13px;
  font-weight: 800;
  color: #0d9488;
  line-height: 1.45;
  text-align: right;
  padding-top: 1px;
}

.d-txt {
  grid-column: 2;
  grid-row: 1;
  margin: 0;
  font-size: 12px;
  line-height: 1.65;
  color: #334155;
}

.d-line {
  position: absolute;
  left: 17px;
  top: 26px;
  bottom: -16px;
  width: 0;
  border-left: 2px dashed rgba(45, 212, 191, 0.75);
}

.d-row--last .d-line {
  display: none;
}

.d-link {
  color: #0d9488;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: default;
}
</style>
